import React from "react";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import FilterableList from "components/ListOption/FilterableList";

import { useAppMeta, useAuth } from "hooks";

import { ENTITY_LIST_OPTIONS } from "data/static";

const EntityListOptionDetailScreen = () => {
  const breadcrumbs = [{ title: "Entity List" }];

  const { viewEntity } = useAuth();

  useAppMeta("Entity List");

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs}>
      <BreadcrumbLayout.Paper>
        <FilterableList
          title={`${viewEntity?.entity?.displayName}'s List`}
          list={ENTITY_LIST_OPTIONS}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default EntityListOptionDetailScreen;
